<template>
  <div>
    <vxe-card size="mini" width="100%">
      <template #title>
        <vxe-input v-model="query.name" clearable placeholder="business.label.name" @clear="refresh" @keydown.native.enter="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
        <vxe-button content="button.add" icon="vxe-icon-add" status="primary" @click="add"/>
      </template>
      <vxe-table
        ref="table"
        :column-config="{resizable: true}"
        :data="data"
        :export-config="{}"
        :height="height"
        :keyboard-config="{isArrow: true}"
        :loading="loading"
        :row-config="{isCurrent: true, isHover: true}"
        :scroll-x="{enabled: true}"
        align="center"
        border
        keep-source
        round
        show-header-overflow
        show-overflow
        size="mini"
        stripe>
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="name" title="business.label.name" width="200"/>
        <vxe-column field="value" title="business.label.parameterValue"/>
        <vxe-column field="enterprise.name" title="business.label.enterprise" width="100"/>
        <vxe-column field="warehouse.name" title="business.label.warehouse" width="100"/>
        <vxe-column field="notes" title="business.label.parameterNote" width="300"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="customized" title="business.label.customized" width="70"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.edit" icon="vxe-icon-edit" status="primary" @click.stop="edit(row)"/>
            <vxe-button content="button.copy" icon="vxe-icon-copy" status="primary" @click.stop="copy(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
      </template>
    </vxe-card>
    <parameter-editor ref="editor" @success="refresh"/>
  </div>
</template>
<script>
import Vue from 'vue'
import { findAll } from '@/api/Api'
import { SCREEN_HEIGHT } from '@/store/mutation-types'
import ParameterEditor from '@/views/config/parameter/ParameterEditor.vue'
import { Parameter } from '@/api/dto/admin/Parameter'

export default {
  name: 'SystemParametersConfig',
  components: { ParameterEditor },
  data() {
    return {
      loading: false,
      data: [],
      query: new Parameter(),
      page: 1,
      size: 20,
      contentSize: 0,
      height: Vue.ls.get(SCREEN_HEIGHT) * (0.8)
    }
  },
  activated() {
    this.refresh()
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      findAll('parameterFactory', this.query.toJSONObject(), this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query = new Parameter(item)
      this.refresh()
    },
    add() {
      this.$refs.editor.add()
    },
    edit(row) {
      this.$refs.editor.edit(row.id, false)
    },
    copy(row) {
      this.$refs.editor.edit(row.id, true)
    }
  }
}
</script>